import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import Loader from "../components/Loader";
import defaultTruck from "../images/default-trucks/defaut-camion-malaxeur.png";
import defaultWorksite from "../images/default-worksite/default-worksite.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faLocationDot,
  faCalendar,
} from "@fortawesome/free-solid-svg-icons";
import { faBookmark } from "@fortawesome/free-regular-svg-icons";
import headerBackground from "../images/header-page.png";
import axios from "axios";

const CompanyPage = () => {
  const { id: companyId } = useParams();
  const [company, setCompany] = useState(null);
  const [user, setUser] = useState(null);
  const [products, setProducts] = useState(null);
  const [loading, setLoading] = useState(true);
  const [worksiteCities, setWorksiteCities] = useState({});

  const loadCity = async (latitude, longitude) => {
    try {
      const response = await axios.get(
        `https://geo.api.gouv.fr/communes?lat=${latitude}&lon=${longitude}&fields=nom&format=json`
      );
      if (response.data && response.data.length > 0) {
        return response.data[0].nom;
      } else {
        return "Ville inconnue";
      }
    } catch (error) {
      console.error("Erreur lors de la récupération de la ville :", error);
      return "Ville inconnue";
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      if (!companyId) {
        console.error("Company ID is not defined");
        return;
      }
      try {
        const companyRes = await axios.get(
          `${process.env.REACT_APP_API_URL}/v1/company/${companyId}`
        );
        setCompany(companyRes.data);

        const userRes = await axios.get(
          `${process.env.REACT_APP_API_URL}/v1/company/user/${companyId}`
        );
        if (!userRes.data) {
          console.error("User data is not defined");
          return;
        }
        setUser(userRes.data);

        const role = userRes.data.roles[0].name;
        if (!role) {
          console.error("Role is not defined");
          return;
        }

        const url =
          role === "transporteur"
            ? `${process.env.REACT_APP_API_URL}/v1/products/company`
            : `${process.env.REACT_APP_API_URL}/v1/worksites/company`;

        const productsRes = await axios.get(`${url}/${companyId}`);
        if (productsRes.data.length === 0) {
          setProducts([]);
        } else {
          setProducts(productsRes.data);
        }
        console.log("Products response:", productsRes.data);
      } catch (err) {
        console.error("Error fetching data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [companyId]);

  const [city, setCity] = useState(false);

  useEffect(() => {
    if (!company) return;
    if (company.longitude && company.latitude) {
      axios
        .get(
          "https://api-adresse.data.gouv.fr/reverse/?lon=" +
            company.longitude +
            "&lat=" +
            company.latitude +
            "&type=municipality"
        )
        .then((response) => {
          if (response.data.features[0].properties.label) {
            setCity(response.data.features[0].properties.label);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [company]);

  useEffect(() => {
    if (!products || user?.roles[0]?.name === "transporteur") return;

    const loadMissingCities = async () => {
      const newCities = {};
      for (const item of products) {
        if (!worksiteCities[item.id]) {
          const city = await loadCity(item.latitude, item.longitude);
          newCities[item.id] = city;
        }
      }
      if (Object.keys(newCities).length > 0) {
        setWorksiteCities((prev) => ({ ...prev, ...newCities }));
      }
    };

    loadMissingCities();
  }, [products, worksiteCities, user]);

  if (loading) return <Loader />;

  return (
    <>
      <div
        className="company-banner"
        style={{ backgroundImage: `url(` + headerBackground + `)` }}
      >
        <div className="bigcontainer">
          <div className="company-section">
            <div className="company-section-explanations">
              <img
                className="company-section-explanations-img"
                src={
                  company.photo
                    ? process.env.REACT_APP_API_URL + company.photo
                    : ""
                }
                alt=""
              />
              <div className="company-section-info">
                <p className="company-section-explanations-name">
                  {company.name}
                </p>
                {city ? (
                  <p className="company-section-explanations-place">
                    <FontAwesomeIcon icon={faLocationDot} /> {city}
                  </p>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div className="company-section-check">
              <div className="company-section-check-text">
                <p>
                  <FontAwesomeIcon icon={faCheck} /> Transporteur vérifié
                </p>
              </div>
              <div className="company-section-check-text">
                <p>
                  <FontAwesomeIcon icon={faBookmark} /> Membre depuis février
                  2023
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bigcontainer">
        <h2>{products.length} annonces</h2>
        <Row>
          {user.roles[0].name === "transporteur"
            ? products.map((item, index) => (
                <Col xs={12} sm={6} lg={4} xl={3} key={index}>
                  <Link className="text-decoration-none" to={item.slug}>
                    <div className="card card-product">
                      <div className="card-product-pic">
                        <img
                          src={
                            item.image && JSON.parse(item.image).length !== 0
                              ? process.env.REACT_APP_API_URL +
                                JSON.parse(item.image)[0]
                              : defaultTruck
                          }
                          alt={item.name}
                        />
                      </div>
                      <div className="card-product-body">
                        <h5 className="card-product-name">{item.name}</h5>
                        <p className="card-product-category">
                          {item.category_name}
                        </p>
                        <div className="card-product-separation">
                          <p className="card-product-presentation">
                            À partir de <br />
                            <span className="card-product-price">
                              {item.price}€/j
                            </span>
                          </p>
                          <Link
                            to={item.slug}
                            className="solu-btn solu-btn-sm solu-btn-primary"
                          >
                            Je réserve
                          </Link>
                        </div>
                      </div>
                    </div>
                  </Link>
                </Col>
              ))
            : products.map((item, index) => {
                const worksiteCity =
                  worksiteCities[item.id] || "Ville non renseignée";
                const datesWorksite = item.dates.map((date) => {
                  const dateObj = new Date(date);
                  return dateObj.toLocaleDateString("fr-FR", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                  });
                });
                const datesWorksiteStart = datesWorksite[0];
                const datesWorksiteEnd =
                  datesWorksite[datesWorksite.length - 1];
                return (
                  <Col xs={12} sm={6} lg={4} xl={3} key={index}>
                    <Link className="text-decoration-none" to={item.slug}>
                      <div className="card card-product">
                        <div className="card-product-pic">
                          <img
                            src={
                              item.image && JSON.parse(item.image).length !== 0
                                ? process.env.REACT_APP_API_URL +
                                  JSON.parse(item.image)[0]
                                : defaultWorksite
                            }
                            alt={item.name}
                          />
                        </div>
                        <div className="card-product-body">
                          <h5 className="card-product-name">{item.name}</h5>
                          <p className="card-product-category">
                            {item.category_name}
                          </p>
                          <p className="card-product-localisation">
                            <FontAwesomeIcon icon={faLocationDot} />
                            {` ${worksiteCity}`}
                          </p>
                          <p className="card-product-localisation">
                            <FontAwesomeIcon icon={faCalendar} /> Du{" "}
                            {datesWorksiteStart} au {datesWorksiteEnd}
                          </p>
                          <div className="card-product-separation">
                            <Link
                              to={`/chantiers/${item.slug}`}
                              className="solu-btn solu-btn-sm solu-btn-primary"
                            >
                              Voir le chantier
                            </Link>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </Col>
                );
              })}
        </Row>
      </div>
    </>
  );
};

export default CompanyPage;
